import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../../components/button/Button';
import PrimaryButton from '../../components/primary-button/PrimaryButton';

import messages from './messages';

import './MetadataInstanceConfirmDialog.scss';

var MetadataInstanceConfirmDialog = function MetadataInstanceConfirmDialog(_ref) {
    var onCancel = _ref.onCancel,
        onConfirm = _ref.onConfirm,
        confirmationMessage = _ref.confirmationMessage;
    return React.createElement(
        'div',
        { className: 'metadata-instance-confirm-cover' },
        React.createElement(
            'div',
            { className: 'metadata-instance-confim-container' },
            React.createElement(
                'p',
                { className: 'metadata-instance-confirm-text' },
                confirmationMessage
            ),
            React.createElement(
                'div',
                { className: 'metadata-instance-confirm-buttons' },
                React.createElement(
                    Button,
                    {
                        'data-resin-target': 'metadata-confirmcancel',
                        type: 'button',
                        onClick: onCancel
                    },
                    React.createElement(FormattedMessage, messages.metadataCancel)
                ),
                React.createElement(
                    PrimaryButton,
                    {
                        'data-resin-target': 'metadata-confirmremove',
                        type: 'button',
                        onClick: onConfirm
                    },
                    React.createElement(FormattedMessage, messages.customRemove)
                )
            )
        )
    );
};

MetadataInstanceConfirmDialog.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    confirmationMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};
export default MetadataInstanceConfirmDialog;
import PropTypes from 'prop-types';